import { useCallback, useState } from "react";

// Keep the customer's collection number until they explicitly start a new order.
// A route remount/reload must not lose the receipt after the server saved it.
export default function useCashReceipt(profile, user) {
    const key = `cayenne.kiosk.cash-receipt.${profile}.${user}`;
    const [receipt, update] = useState(() => ({ key, name: sessionStorage.getItem(key) }));
    const setReceipt = useCallback(name => {
        if (name) sessionStorage.setItem(key, name);
        else sessionStorage.removeItem(key);
        update({ key, name });
    }, [key]);
    return [receipt.key === key ? receipt.name : sessionStorage.getItem(key), setReceipt];
}
